<template>
  <div class="refresh" :style="'height:' + (clientHeight - 140) + 'px'">
    <div style="text-align: center">
      <img
        src="../../../public/static/images/netError.jpg"
        style="margin-top: 30px;width: 40%"
        alt=""
      />
    </div>
    <el-button @click="onRefresh" icon="arrow-left" class="pan-back-btn">点我刷新</el-button>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "refresh",
  computed: {
    ...mapState(["networkSuccess"])
  },
  data() {
    return {
      clientHeight: 0
    };
  },
  mounted() {
    // 屏幕可视区域的高度  document.documentElement.clientHeight
    this.clientHeight = document.documentElement.clientHeight;
    window.onresize = function() {
      this.clientheight = document.documentElement.clientHeight;
    };
  },
  methods: {
    onRefresh() {
      this.$router.go(-1); // 返回之前点击的页面
    }
  }
};
</script>

<style scoped>
.refresh {
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
  background: white;
  text-align: center;
}
.pan-back-btn {
  background: #008489;
  color: #fff;
  margin: 10px auto;
}
</style>
